import client from './client';

const users = {
  getAll:          ()         => client.get('/users/'),
  getOne:          (id)       => client.get(`/users/${id}/`),
  create:          (data)     => client.post('/users/', data),
  update:          (id, data) => client.patch(`/users/${id}/`, data),
  deactivate:      (id)       => client.post(`/users/${id}/deactivate/`),
  activate:        (id)       => client.post(`/users/${id}/activate/`),
  resetPassword:   (id, data) => client.post(`/users/${id}/reset-password/`, data),
  changePassword:  (id, data) => client.post(`/users/${id}/change-password/`, data),

  // Districts / locations (needed for admin forms)
  getDistricts:    ()         => client.get('/districts/'),
  getLocations:    ()         => client.get('/locations/'),
  getBuildings:    ()         => client.get('/buildings/'),
  createLocation:  (data)     => client.post('/locations/', data),
  updateLocation:  (id, data) => client.patch(`/locations/${id}/`, data),
  deleteLocation:  (id)       => client.delete(`/locations/${id}/`),
  createBuilding:  (data)     => client.post('/buildings/', data),
  deleteBuilding:  (id)       => client.delete(`/buildings/${id}/`),
};

export default users;
